module.exports = __webpack_public_path__ + "img/brown.7023854f.svg";